import { render, staticRenderFns } from "./MenteeBasicCard.vue?vue&type=template&id=683ce82c&scoped=true&"
import script from "./MenteeBasicCard.vue?vue&type=script&lang=js&"
export * from "./MenteeBasicCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683ce82c",
  null
  
)

export default component.exports